import { render, staticRenderFns } from "./DongSen.vue?vue&type=template&id=4f25e7a8&scoped=true&"
import script from "./DongSen.vue?vue&type=script&lang=ts&"
export * from "./DongSen.vue?vue&type=script&lang=ts&"
import style0 from "./DongSen.vue?vue&type=style&index=0&id=4f25e7a8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f25e7a8",
  null
  
)

export default component.exports